import { Box, Grid, Typography } from '@mui/material'
import { Face } from '@mui/icons-material'
import { format, formatDistanceToNowStrict } from 'date-fns'
import React from 'react'
import { useSelector } from 'react-redux'
import { UserListSlice } from '../../../reducers'
import { StatusMap } from '../components/status'
import { useStyles } from './style'

const Summary = () => {
  const { detail, subscription } = useSelector(
    UserListSlice.selectors.selectUser
  )
  const classes = useStyles({ state: subscription?.state })

  return (
    <Grid
      container
      data-test='consumer-summmary'
      spacing={1}
      justifyContent='center'
    >
      <Grid item xs={3}>
        <Box className={classes.avatar} data-test='consumer-avatar'>
          <Face color='primary' />
        </Box>
      </Grid>
      <Grid container direction='column' item xs>
        <Typography variant='caption'>Contact</Typography>
        <Typography
          variant='body2'
          className={classes.email}
          data-test='consumer-email'
          gutterBottom
        >
          {detail.email}
        </Typography>
        <Typography
          variant='caption'
          className={classes.status}
          data-test='consumer-subscription-status'
        >
          {subscription?.state ? StatusMap[subscription.state].name : 'No'}{' '}
          subscription
        </Typography>
        <Typography variant='caption' data-test='consumer-last-access'>
          Last access:{' '}
          {detail?.lastAccess
            ? formatDistanceToNowStrict(new Date(detail.lastAccess))
            : "Hasn't signed in"}
        </Typography>
        <Typography variant='caption' data-test='consumer-member-since'>
          Member since: {format(new Date(detail.createdAt), 'MMM d, y')}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Summary
